import {useSelector} from 'react-redux';
import {selectSystemDisabled} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {Typography} from '~library/atoms/Typography';
import './DisabledWarning.sass';

export const DisabledWarning = () => {
  const disabled = useSelector(selectSystemDisabled);
  if (!disabled) {
    return null;
  }

  return (
    <div className="disabled-warning">
      <Typography variant="paragraph2" color="mexicanOpalWebText">
        eGift Cards are temporarily unavailable
      </Typography>
      <Typography variant="paragraph3" color="mexicanOpalWebText">
        You can still proceed with your Greeting Card.
      </Typography>
    </div>
  );
};
